import axios from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';

export const fetchDashboard = () => {
	const requestURL = `${appConfig.env.urlSpringAPI}/dashboard`;
	return axios.get(requestURL);
};

export const fetchDashboardMeasurement = () => {
	const requestURL = `${appConfig.env.urlSpringAPI}/dashboard/tracking`;
	return axios.get(requestURL);
};

export const fetchDashboardMeasurementDiagram = (type: string) => {
	const requestURL = `${appConfig.env.urlSpringAPI}/dashboard/trackingdiagram/${type}`;
	return axios.get(requestURL);
};

export const postDashboardMeasurement = (data: Object) => {
	const requestURL = `${appConfig.env.urlSpringAPI}/dashboard/tracking`;
	return axios.post(requestURL, data, { params: data });
};
